export default __webpack_public_path__ + "static/media/playBlack.2543a376.svg";